import TaxesPage from "./TaxesPage";

export default [
    {
        path: "/taxes",
        name: "taxes",
        component: TaxesPage
    }
]
